<template>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ logss }}
      <v-btn
        dark
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
</template>

<script>
  import { mapState } from 'vuex'
  import store from "@/store"

  export default {
    ...mapState({
      logMessage: state => state.util.logMessage
    }),
    computed: {
      logss: function  () {
        if (this.logs) {
          this.logs
        } else {
          return '0'
        }
      }
    },
    mounted: function () {
      this.$store.watch(
        (state, getters) => getters.getLogMessage,
        (newValue, oldValue) => {
          console.log(`Updating from ${oldValue} to ${newValue}`);

          // Do whatever makes sense now
          
        }
      );
    },
    watch: {
      logMessage: function  () {
        this.snackbar = true
      }
    },
    data () {
      return {
        snackbar: false,
        color: '',
        mode: '',
        timeout: 6000
      }
    }
  }
</script>